import getProp from '@f/get-prop'
import formatRequestKey from 'lib/utils/format-request-key'

export const getRequest = (state, type, requestKey) =>
  getProp(`requests.${type}.${requestKey}`, state) || {}

export const getUpdateSourceRequest = (state, workspaceSlug, sourceSlug) => {
  const requestKey = formatRequestKey('updatesource', workspaceSlug, sourceSlug)
  return getRequest(state, 'updateSource', requestKey)
}



// WEBPACK FOOTER //
// ./selectors/requests.js